<div class="kt-container  kt-grid__item kt-grid__item--fluid">

    <!--Begin::App-->
    <div class="kt-grid kt-grid--desktop kt-grid--ver kt-grid--ver-desktop kt-app">

        <!--Begin:: App Aside Mobile Toggle-->
        <button class="kt-app__aside-close" id="kt_user_profile_aside_close">
            <i class="la la-close"></i>
        </button>

        <!--End:: App Aside Mobile Toggle-->

        <!--Begin:: App Aside-->
        <div class="kt-grid__item kt-app__toggle kt-app__aside" id="kt_user_profile_aside">

            <!--begin:: Widgets/Applications/User/Profile4-->
            <div class="kt-portlet kt-portlet--height-fluid-">
                <div class="kt-portlet__body">

                    <!--begin::Widget -->
                    <div class="kt-widget kt-widget--user-profile-4">
                        <div class="kt-widget__head">
                            <div class="kt-widget__media">
                                <img class="kt-widget__img kt-hidden-" *ngIf="isImage"
                                    src="{{assetsPath + userBasicInfo.image}}" alt="image">
                                <img class="kt-widget__img kt-hidden-" *ngIf="!isImage"
                                    src="/assets/media/users/default.jpg" alt="image">
                                <div
                                    class="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-boldest kt-font-light kt-hidden">
                                    AD
                                </div>
                            </div>
                            <div class="kt-widget__content">
                                <div class="kt-widget__section">
                                    <a href="#" class="kt-widget__username">
                                        {{ userBasicInfo.displayName}}
                                    </a>
                                    <div class="kt-widget__button">
                                        <span class="btn btn-label-warning btn-sm">Aktif Gönüllü</span> <br
                                            *ngIf="userBasicInfo.isAlumni"><br *ngIf="userBasicInfo.isAlumni">
                                        <span class="btn btn-label-brand btn-sm"
                                            *ngIf="userBasicInfo.isAlumni">Mezun</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="kt-widget__body">
                            <a [routerLink]="['/my-profile']" class="kt-widget__item">
                                Genel Bilgiler
                            </a>
                            <a [routerLink]="['/update-my-basic-information']" class="kt-widget__item">
                                Temel Bilgilerimi Güncelle
                            </a>
                            <a [routerLink]="['/update-my-role-settings']" class="kt-widget__item">
                                Gönüllülük Alanlarım
                            </a>
                            <a [routerLink]="['/update-my-password']" class="kt-widget__item">
                                Şifremi Değiştir
                            </a>
                            <a [routerLink]="['/my-profession-list']" class="kt-widget__item">
                                Kariyer Bilgilerim
                            </a>
                            <a [routerLink]="['/my-education-list']" class="kt-widget__item">
                                Eğitim Bilgilerim
                            </a>
                            <a [routerLink]="['/judge-form']" class="kt-widget__item kt-widget__item--active">
                                Jürilik Bilgi Formu
                            </a>
                            <a [routerLink]="['/referee-form']" class="kt-widget__item">
                                Hakemlik Bilgi Formu
                            </a>
                        </div>
                    </div>

                    <!--end::Widget -->
                </div>
            </div>

            <!--end:: Widgets/Applications/User/Profile4-->

            <!--Begin:: Portlet-->
            <div class="kt-portlet">
                <div class="kt-portlet__body">
                    <div class="kt-widget1 kt-widget1--fit">
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Başvurularım</h3>
                                <span class="kt-widget1__desc">Aktif başvuru sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-brand">0</span>
                        </div>
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Rozetlerim</h3>
                                <span class="kt-widget1__desc">Rozet sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-success">0</span>
                        </div>
                    </div>
                </div>
            </div>

            <!--end:: Portlet-->
        </div>

        <!--End:: App Aside-->

        <!--Begin:: App Content-->
        <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
            <div class="kt-portlet__body" *ngIf="isFilled && !isUpdated">

                <!--begin::Section-->
                <div class="kt-section">
                    <div class="kt-section__content">
                        <div class="kt-demo">
                            <div class="kt-demo__preview">
                                <div class="alert alert-warning" role="alert">
                                    <div class="alert-text">
                                        <h4 class="alert-heading">Lütfen juri başvuru formu yanıtlarınızı güncelleyin!</h4>
                                        <hr>
                                        <p>Daha önce doldurmuş olduğunuz juri başvurumu formu bulunmaktadır. Başvurunuzun bu sezonda da geçerli olabilmesi için lütfen cevaplarınızı düzenleyip kaydet butonuna basınız. Güncelleyecek bir cevabınız yok ise sadece kaydet butonuna basmanız yeterli olacaktır.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--end::Section-->
            </div>
            <div class="kt-portlet__body" *ngIf="isFilled && isUpdated">

                <!--begin::Section-->
                <div class="kt-section">
                    <div class="kt-section__content">
                        <div class="kt-demo">
                            <div class="kt-demo__preview">
                                <div class="alert alert-success" role="alert">
                                    <div class="alert-text">
                                        <h4 class="alert-heading">Juri başvurunuz geçerlidir. Formu doldurduğunuz ve güncellediğiniz için teşekkür ederiz.</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--end::Section-->
            </div>
            <div class="row">
                <div class="col-xl-12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__head">
                            <div class="kt-portlet__head-label">
                                <h3 class="kt-portlet__head-title">Jürilik Bilgi Formu</h3>
                            </div>
                        </div>
                        <!-- <div class="kt-portlet__body" *ngIf="isFilled">
                            <div class="kt-section kt-section--first">
                                <div class="kt-section__body">
                                    <div class="form-group">
                                        <p>Formu doldurduğunuz için teşekkür ederiz.</p>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <form [formGroup]="createJudgeForm" (ngSubmit)="save()" class="kt_login_form">
                            <div class="kt-portlet__body">
                                <div class="kt-section kt-section--first">
                                    <div class="kt-section__body">

                                        <div class="form-group">
                                            <h5>Lütfen formu doldurmadan önce eğitim ve kariyer bilgilerinizi tamamen
                                                giriniz. Eğitim ve kariyer bilgileriniz de formun bir parçası olacaktır.
                                                Profil ekranındaki menüleri kullanarak <a
                                                    [routerLink]="['/my-education-list']">eğitim</a> ve <a
                                                    [routerLink]="['/my-profession-list']">kariyer</a> bilgilerinizi
                                                girebilirsiniz.</h5>
                                            <hr>
                                            <p>Bilim Kahramanları Buluşuyor turnuvalarının mümkün olduğunca adil bir
                                                değerlendirme sürecine sahip olması, ve bu konuda oluşabilecek herhangi
                                                bir negatif algıya engel olmak amacıyla, turnuvalardaki jüri düzenini,
                                                jüri üyeleri ve takımlar arasında çıkar çatışması durumu oluşmayacak
                                                şekilde gerçekleştiriyoruz. <br><br>

                                                2022-2023 sezonu içerisinde takım koç ve danışmanı olarak görev alacak
                                                kişiler jüri başvurusu yapamayacaktır. Bu şartlara uymayarak yapılan
                                                jüri başvuruları kabul edilmeyecektir. <br><br>

                                                Ek olarak, <br><br>

                                                1) Eğer bir okula / kuruma bağlı iseniz ve bu okul / kurum seçtiğiniz
                                                turnuvada takım çıkartıyorsa,<br>2) Eğer seçtiğiniz turnuvada herhangi
                                                bir çocuğunuz bir takımda yer
                                                alıyorsa, <br><br>

                                                lütfen aşağıdaki yanıtınızda bunu bizimle paylaşın.</p>
                                            <label>Yukarıdaki tanıma uyan bir durumunuz var
                                                mı?</label>
                                            <div class="kt-radio-list">
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isConflict" value="yes"
                                                        formControlName="isConflict">
                                                    Evet
                                                    <span></span>
                                                </label>
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isConflict" value="no"
                                                        formControlName="isConflict">
                                                    Hayır
                                                    <span></span>
                                                </label>
                                            </div>
                                            <small class="form-text text-warning"
                                                *ngIf="f.isConflict.errors?.required">Lütfen bir seçenek
                                                işaretleyiniz!</small>
                                        </div>

                                        <div class="form-group">
                                            <label>Daha önce herhangi bir gönüllülük tecrübeniz oldu mu?</label>
                                            <div class="kt-radio-list">
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isVolunteeredBefore" value="yes"
                                                        formControlName="isVolunteeredBefore"> Evet
                                                    <span></span>
                                                </label>
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isVolunteeredBefore" value="no"
                                                        formControlName="isVolunteeredBefore"> Hayır
                                                    <span></span>
                                                </label>
                                            </div>
                                            <small class="form-text text-warning"
                                                *ngIf="f.isVolunteeredBefore.errors?.required">Lütfen bir seçenek
                                                işaretleyiniz!</small>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-form-label">Gönüllülük tecrübeniz olduysa
                                                detaylandırınız</label>

                                            <textarea formControlName="volunteerExperience" rows="3"
                                                class="form-control" placeholder="Tecrübeniz.."></textarea>
                                            <small class="form-text text-warning"
                                                *ngIf="f.volunteerExperience.errors?.maxlength">Lütfen 1000 karakteri
                                                geçmeyiniz!</small>
                                        </div>
                                        <div class="form-group">
                                            <label>Daha önceki turnuvalarda jürilik yaptınız mı?</label>
                                            <div class="kt-radio-list">
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isJudgedBefore" value="yes"
                                                        formControlName="isJudgedBefore"> Evet
                                                    <span></span>
                                                </label>
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isJudgedBefore" value="no"
                                                        formControlName="isJudgedBefore"> Hayır
                                                    <span></span>
                                                </label>
                                            </div>
                                            <small class="form-text text-warning"
                                                *ngIf="f.isJudgedBefore.errors?.required">Lütfen bir seçenek
                                                işaretleyiniz!</small>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-form-label">Hangi sezon(lar)da jüri oldunuz?</label>

                                            <div class="kt-checkbox-list">
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onEventChange('2018 - 2019 INTO ORBIT: Uzay Serüveni', $event.target.checked)" name="firstEvent" type="checkbox" [checked]="eventSelection.firstEvent"> 2018 -
                                                    2019 INTO ORBIT: Uzay Serüveni
                                                    <span></span>
                                                </label>
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onEventChange('2019 - 2020 CITY SHAPER: Şehri Şekillendir', $event.target.checked)" name="secondEvent" type="checkbox" [checked]="eventSelection.secondEvent"> 2019 - 2020 CITY SHAPER:
                                                    Şehri Şekillendir
                                                    <span></span>
                                                </label>
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onEventChange('2020 - 2021 RePLAY', $event.target.checked)" name="third" type="checkbox" [checked]="eventSelection.thirdEvent"> 2020 - 2021 RePLAY
                                                    <span></span>
                                                </label>
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onEventChange('2021 - 2022 Cargo Connect', $event.target.checked)" name="fourth" type="checkbox" [checked]="eventSelection.fourthEvent"> 2021 - 2022 Cargo Connect
                                                    <span></span>
                                                </label>
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onEventChange('2022 - 2023 Superpowered', $event.target.checked)" name="fifth" type="checkbox" [checked]="eventSelection.fifthEvent"> 2022 - 2023 Superpowered
                                                    <span></span>
                                                </label>
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onEventChange('2023 - 2024 Masterpiece', $event.target.checked)" name="sixth" type="checkbox" [checked]="eventSelection.sixthEvent"> 2023 - 2024 Masterpiece
                                                    <span></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label>Robotik kodlama tecrübeniz var mı?</label>
                                            <div class="kt-radio-list">
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isProgramming" value="yes"
                                                        formControlName="isProgramming"> Evet
                                                    <span></span>
                                                </label>
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isProgramming" value="no"
                                                        formControlName="isProgramming"> Hayır
                                                    <span></span>
                                                </label>
                                            </div>
                                            <small class="form-text text-warning"
                                                *ngIf="f.isProgramming.errors?.required">Lütfen bir seçenek
                                                işaretleyiniz!</small>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-form-label">Bildiğiniz programlama dilleri
                                                nelerdir?</label>

                                                <div class="kt-checkbox-list">
                                                    <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                        <input (change)="onLanguageChange('EV3', $event.target.checked)" name="ev3" type="checkbox" [checked]="languageSelection.ev3"> EV3
                                                        <span></span>
                                                    </label>
                                                    <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                        <input (change)="onLanguageChange('Scratch', $event.target.checked)" name="scratch" type="checkbox" [checked]="languageSelection.scratch"> Scratch
                                                        <span></span>
                                                    </label>
                                                    <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                        <input (change)="onLanguageChange('Python', $event.target.checked)" name="python" type="checkbox" [checked]="languageSelection.python"> Python
                                                        <span></span>
                                                    </label>
                                                </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-form-label">Neden jüri olmak istiyorsunuz?</label>

                                            <textarea formControlName="judgeExplanation" rows="3" class="form-control"
                                                placeholder="Açıklayınız.."></textarea>
                                            <small class="form-text text-warning"
                                                *ngIf="f.judgeExplanation.errors?.required">Lütfen neden jüri olmak
                                                istediğinizi yazınız!</small>
                                            <small class="form-text text-warning"
                                                *ngIf="f.judgeExplanation.errors?.maxlength">Lütfen 1000 karakteri
                                                geçmeyiniz!</small>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-form-label">Bilim Kahramanları Derneği'nden bir
                                                referansınızı yazınız. (varsa)</label>
                                            <textarea formControlName="reference" rows="3" class="form-control"
                                                placeholder="Referans bilgisi.."></textarea>
                                            <small class="form-text text-warning"
                                                *ngIf="f.reference.errors?.maxlength">Lütfen 250 karakteri
                                                geçmeyiniz!</small>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-form-label">Formu doldurduğunuz için teşekkür ederiz. Ek
                                                görüşleriniz varsa lütfen yazınız.</label>
                                            <textarea formControlName="additionalThoughts" rows="3" class="form-control"
                                                placeholder="Ek görüşleriniz.."></textarea>
                                            <small class="form-text text-warning"
                                                *ngIf="f.additionalThoughts.errors?.maxlength">Lütfen 1000 karakteri
                                                geçmeyiniz!</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="kt-portlet__foot">
                                <div class="kt-form__actions">
                                    <div class="row">
                                        <div class="col-lg-9 col-xl-9">
                                            <button type="submit" class="btn btn-success btn-bold">Kaydet</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!--End:: App Content-->
    </div>

    <!--End::App-->
</div>